import Backbone from 'backbone'
import $ from 'jquery'

// Silly
Backbone.$ = $

import Canvas from './lib/canvas'
import EditableCanvas from './lib/editable-canvas'
import FullwidthCanvas from './lib/full-width-canvas'
import FullscreenCanvas from './lib/fullscreen-canvas'
import ScalableCanvas from './lib/scalable-canvas'
import {Wob, Connector} from './lib/wob'
import Wobs from './lib/wobs'
import edges from './lib/support/edges'
import draggable from './lib/support/draggable'
import droppable from './lib/support/droppable'
import marquee from './lib/support/marquee'
import keybindings from './lib/support/keybindings'

export {
  Canvas,
  Connector,
  EditableCanvas,
  FullscreenCanvas,
  FullwidthCanvas,
  ScalableCanvas,
  Wob,
  Wobs
}

/*
 * These functions can be used by the editable canvas.
 *  e.g. if you want your editable canvas to support draggable wobs
 *        ```
 *          canvas.use(canvas.features.draggable)
 *        ```
 */
export const features = {
  edges,
  draggable,
  droppable,
  marquee,
  keybindings
}
